import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCurrencyPipe } from './custom-currency.pipe';
import { FormsModule } from '@angular/forms';
import { EurosPipe } from '../../pipes/euros.pipe';
import { RemoveParenthesesPipe } from '../../pipes/remove.parentheses.pipe';
import { ProjectStatusLabelPipe } from '../../pipes/project-status-label.pipe';
import { PaginationComponent } from '../UI/pagination/pagination.component';
import { SpinnerComponent } from '../UI/spinner/spinner.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ReactiveFormsModule } from '@angular/forms';
import { Verify2FAModalComponent } from './verify-2fa-modal/verify-2fa-modal.component';
import { Setup2FaModalComponent } from './setup-2fa-modal/setup-2fa-modal.component';

@NgModule({
  declarations: [
    CustomCurrencyPipe,
    EurosPipe,
    RemoveParenthesesPipe,
    PaginationComponent,
    Verify2FAModalComponent,
    Setup2FaModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ProjectStatusLabelPipe,
    MatProgressSpinnerModule,
    SpinnerComponent,
    ReactiveFormsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    CustomCurrencyPipe,
    EurosPipe,
    RemoveParenthesesPipe,
    PaginationComponent,
    ProjectStatusLabelPipe,
    SpinnerComponent,
    ReactiveFormsModule,
    Verify2FAModalComponent,
    Setup2FaModalComponent
  ]
})
export class SharedModule { }
